import { render, staticRenderFns } from "./rsmigeneration.vue?vue&type=template&id=198d495e&"
import script from "./rsmigeneration.vue?vue&type=script&lang=js&"
export * from "./rsmigeneration.vue?vue&type=script&lang=js&"
import style0 from "./rsmigeneration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports